import React, { useState, forwardRef, useImperativeHandle, useEffect } from "react";
import { CustomConfirmAlert as confirmAlert } from '../../custom-confirm-alert';
import { useTranslation } from 'react-i18next';
import { Menu, MenuItem, MenuButton } from '@szhsin/react-menu';
import ApiClient from "../../../services/api-client"
import { toast } from 'react-toastify';
import useStore from "../../../hooks/useStore";

const TransactionActionsRenderer = forwardRef((props, ref) => {
    const { t } = useTranslation();
    const [actionElement, setActionElement] = useState(<span></span>);

    const handleCancel = () => {
        var companyId = useStore.getState().selectedCompany.id;

        confirmAlert({
            title: t("submitConfirm"),
            message: t("cancelationConfirm0"),
            submessage: t("cancelationConfirm2"),
            buttons: [
                {
                    label: t('Yes'),
                    onClick: () => {
                        var rowNode = props.node;
                        props.colDef.cellRendererParams.blockUi(true)
                        var request = {
                            signature: props.data.signature,
                            externalSystemId: props.data.saleInstance ? props.data.saleInstance.id : null,
                            transactionId: props.data.posTransaction ? props.data.posTransaction.transactionId : null,
                            voidTransactionId: props.data.posTransaction ? props.data.posTransaction.transactionId : null
                        }
                        ApiClient.cancelRequestPayment(companyId, request).then(
                            response => {
                                const data = response.data;
                                props.colDef.cellRendererParams.blockUi(false)
                                if (data.status == 1) {
                                    toast.success(t("cancelPaymentAndTransactionSucceded"), { autoClose: 20000 });
                                } else if (data.status == 2) {
                                    toast.success(t("cancelPaymentSucceded"), { autoClose: 20000 });
                                } else {
                                    toast.error(t(data.errorMessage), { autoClose: 20000 });
                                }
                                props.api.refreshInfiniteCache();
                            },
                            error => {
                                console.error(
                                    (error.response && error.response.data && error.response.data.message) ||
                                    error.message || error.toString()
                                )
                                props.colDef.cellRendererParams.blockUi(false)
                            }
                        );
                    }
                },
                { label: t('No'), onClick: () => {} }
            ]
        });
    }

    const handleRefund = () => {
        var companyId = useStore.getState().selectedCompany.id;

        confirmAlert({
            title: t("submitConfirm"),
            message: t("cancelationConfirm0"),
            submessage: t("cancelationConfirm2"),
            buttons: [
                {
                    label: t('Yes'),
                    onClick: () => {
                        var rowNode = props.node;
                        props.colDef.cellRendererParams.blockUi(true)
                        ApiClient.refundRequestPayment(companyId, props.data.posTransaction.transactionId).then(
                            response => {
                                const data = response.data;
                                props.colDef.cellRendererParams.blockUi(false)
                                if (data.Status == 3 && data.Result == 1) {
                                    toast.success(t("refundPaymentSucceded"), { autoClose: 20000 });
                                } else if (data.Status == 3) {
                                    toast.error(t("refundPaymentNotInComplete", { "result": t(data.Result) }), { autoClose: 20000 });
                                } else {
                                    toast.error(t("refundPaymentNotSucceded"), { autoClose: 20000 });
                                }
                                props.api.refreshInfiniteCache();
                            },
                            error => {
                                console.error(
                                    (error.response && error.response.data && error.response.data.message) ||
                                    error.message || error.toString()
                                )
                                props.colDef.cellRendererParams.blockUi(false)
                            }
                        );
                    }
                },
                { label: t('No'), onClick: () => {} }
            ]
        });
    }

    const handleRefresh = () => {
        var companyId = useStore.getState().selectedCompany.id;

        confirmAlert({
            title: t("submitConfirm"),
            message: t("cancelationConfirm0"),
            submessage: t("cancelationConfirm2"),
            buttons: [
                {
                    label: t('Yes'),
                    onClick: () => {
                        var rowNode = props.node;
                        props.colDef.cellRendererParams.blockUi(true)
                        ApiClient.refreshTransaction(companyId, props.data.posTransaction.customerReference).then(
                            response => {
                                props.colDef.cellRendererParams.blockUi(false)
                                props.api.refreshInfiniteCache();
                            },
                            error => {
                                console.error(
                                    (error.response && error.response.data && error.response.data.message) ||
                                    error.message || error.toString()
                                )
                                props.colDef.cellRendererParams.blockUi(false)
                            }
                        );
                    }
                },
                { label: t('No'), onClick: () => {} }
            ]
        });
    }

    useImperativeHandle(ref, () => ({
        refresh(params) {}
    }));

    useEffect(() => {
        if (props.node.data != null) {
            const actionel = <div>
                <Menu menuButton={<MenuButton><span style={{ color: 'black' }}><i className="fa fa-bars"></i></span></MenuButton>} transition>
                    <MenuItem onClick={handleCancel}><i className="fa fa-times"></i>{t("cancelRequestPaymentMenu")}</MenuItem>
                    {props.node.data.posTransaction && props.node.data.posTransaction.transactionId && props.node.data.posTransaction.refundTransactionId == null
                        ? <MenuItem onClick={handleRefund}><i className="fa fa-undo"></i>{t("refundRequestPaymentMenu")}</MenuItem>
                        : <></>}
                    {props.node.data.posTransaction && (props.node.data.posTransaction.status == "SENT" || props.node.data.posTransaction.status == "UNKNOWN")
                        ? <MenuItem onClick={handleRefresh}><i className="fa fa-download"></i>{t("refreshTransactionMenu")}</MenuItem>
                        : <></>}
                </Menu>
            </div>
            setActionElement(actionel)
        }
    }, [props.node])

    return <span>{actionElement}</span>;
});

export default TransactionActionsRenderer;
